if (!customElements.get('submenu-links')) {
  class SubmenuLinks extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        trigger: '.js-submenu-trigger',
      };
    }

    connectedCallback() {
      const triggers = this.querySelectorAll(this.selectors.trigger);

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.showSubmenu.bind(this));
      });
    }

    showSubmenu(e) {
      const trigger = e.currentTarget;
      const submenu = trigger.parentNode.nextElementSibling;
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        submenu.setAttribute('aria-hidden', 'true');
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        submenu.setAttribute('aria-hidden', 'false');
      }
    }
  }

  customElements.define('submenu-links', SubmenuLinks);
}
